import { IOffice } from 'src/models/company';

export const formatOffice = (office: IOffice) =>
  office && [office?.street, office?.city, office?.country].filter(Boolean).join(', ');

async function handleUrl(url) {
  const response = await fetch(url).catch(error => Promise.reject(new Error('Error fetching data')));

  const json = await response.json().catch(() => {
    console.log('Error parsing server response');
    return Promise.reject(new Error('Error parsing server response'));
  });

  if (json.status === 'OK') {
    console.log(json);
    return json;
  }
  console.log(`Server returned status code ${json.status}`, true);
  return Promise.reject(new Error(`Server returned status code ${json.status}`));
}

const GOOGLE_API = 'https://maps.googleapis.com/maps/api/geocode/json';

export async function getCoordinatesOfAddress(address) {
  if (!address) {
    console.log('Provided address is invalid');
    return Promise.reject(new Error('Provided address is invalid'));
  }

  let url = `${GOOGLE_API}?address=${encodeURI(address)}`;

  if (process.env.PUBLIC_GOOGLE_MAPS_API_KEY) {
    url += `&key=${process.env.PUBLIC_GOOGLE_MAPS_API_KEY}`;
  }

  return handleUrl(url);
}
